<template>

  <div>
    <Fontnavbar title="收货地址" />
    <van-address-list v-model="chosenAddressId" :list="address" :switchable="selectStatus" default-tag-text="默认" @add="onAdd" @edit="onEdit" @select="onSelect" />
  </div>

</template>

<script>
import { getAddress } from '../../../api.js'
import { post } from '../../../request.js'
import { AddressList } from 'vant'
import Fontnavbar from "../../../components/Navbar.vue";
export default {
  components: {
    [AddressList.name]: AddressList,
    Fontnavbar
  },
  data () {
    return {
      chosenAddressId: '0',
      selectStatus: false,
      address: [],
    }
  },
  mounted () {
    const that = this
    if (that.$route.query.select) {
      that.selectStatus = true
    }
    if (that.$route.query.address_id) {
      that.chosenAddressId = that.$route.query.address_id.toString()
    }
    post(getAddress, {}).then((res) => {
      if (res.code == 200) {
        that.address = res.data
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            that.address[i].id = res.data[i].id.toString()
            that.address[i].name = res.data[i].user_name
            that.address[i].tel = res.data[i].user_phone
            that.address[i].address = res.data[i].province + res.data[i].city + res.data[i].district + res.data[i].address
            that.address[i].isDefault = res.data[i].is_default == 1 ? true : false
          }
        }
      } else if (res.code == 201) {
        this.$router.push({ path: '/user/login' });
      }
    })
  },

  methods: {
    onAdd () {
      this.$router.push({ path: '/user/address/edit' })
    },

    onEdit (item) {
      this.$router.push({ path: '/user/address/edit?address_id=' + item.id })
    },

    onSelect (item) {
      var that = this
      var address = {
        'id': item.id,
        'user_name': item.name,
        'user_phone': item.tel,
        'address': item.address
      }
      that.$store.commit("setUserAddress", address)
      setTimeout(function () {
        that.$router.go(-1);
      }, 200)
    }
  },

};

</script>

<style lang="less" scoped>
.login-btn {
  margin: 15px;
}
.login-tip {
  margin: 15px 15px 0;
  font-size: 14px;
  color: #f00;
  text-align: right;
}
.login-tip span {
  margin: 0px 5px;
}
</style>
